const constants = {
    testPublicKey: `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEc3OipktkmEbaVhRQWteRJ9/q2b/N
RoDyldq5JlsFei1Zd1Wfhy61pJyy7ZHPKaeKaCt0CvIgrRgcXzgezDbE7A==
-----END PUBLIC KEY-----`,
    googleProductionPublicKey: `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAERUlUpxshr67EO66ZTX0Fpog0LEHc
nUnlSsIrOfroxTLu2XnigBK/lfYRxzQWq9K6nqsSjjYeea0T12r+y3nvqg==
-----END PUBLIC KEY-----`,
    testMerchantId: "42424242"
};

export default constants;